function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'white-ffffff': '','athletic-heather': 'rgb(199, 199, 197)','heather-red': 'rgb(221, 53, 60)','soft-cream': 'rgb(241, 218, 183)','heather-mint': 'rgb(187, 225, 202)','heather-orchid': 'rgb(238, 102, 170)','heather-sunset': 'rgb(255, 176, 156)','heather-raspberry': 'rgb(213, 98, 128)','heather-storm': 'rgb(167, 165, 173)','dark-grey-heather': 'rgb(28, 27, 28)','black': 'rgb(0, 0, 0)','black-heather': 'rgb(8, 7, 6)','heather-red': 'rgb(221, 53, 60)','true-blue': 'rgb(43, 77, 164)','navy': 'rgb(26, 31, 53)','heather-midnight-navy': 'rgb(58, 58, 72)','heather-navy': 'rgb(46, 46, 60)','heather-peach': 'rgb(255, 202, 172)','vintage-white': 'rgb(240, 236, 232)','heather-stone': 'rgb(176, 172, 152)','heather-cool-grey': 'rgb(209, 197, 192)','heather-mauve': 'rgb(209, 135, 134)','heather-dust': 'rgb(240, 232, 225)','heather-cement': 'rgb(247, 244, 239)','heather-ice-blue': 'rgb(243, 255, 255)','soft-pink': 'rgb(255, 234, 229)','sport-grey': 'rgb(202, 202, 202)','grey-concrete': 'rgb(131, 136, 129)','iron-grey': 'rgb(89, 89, 89)','vegas-gold': 'rgb(227, 216, 173)','navy-blue': 'rgb(53, 64, 90)','olive-green': 'rgb(98, 111, 74)','charcoal-heather': 'rgb(55, 55, 55)','heather-grey': 'rgb(186, 186, 186)','oatmeal-heather': 'rgb(242, 241, 231)','pale-pink': 'rgb(240, 200, 180)','mint': 'rgb(143, 209, 218)','blue-lake': 'rgb(95, 141, 218)','texas-orange': 'rgb(185, 98, 68)','royal': 'rgb(0, 6, 255)','dark-heather': 'rgb(69, 69, 69)','blue-red': '','dark-navy': 'rgb(54, 54, 81)','royal': 'rgb(50, 80, 175)','ash': 'rgb(233, 233, 233)','carolina-blue': 'rgb(123, 164, 219)','heliconia': 'rgb(223, 80, 134)','sand': 'rgb(220, 210, 190)','antique-sapphire': 'rgb(0, 130, 174)','charcoal': 'rgb(88, 85, 89)','azalea': 'rgb(239, 143, 188)','graphite-heather': 'rgb(121, 124, 126)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
